import {DateFormat} from '../../../../date_format'
import ViewTTStore from '../../ViewTTStore'
import messageResource from '../../../../messageResource'
import BaseTooltip from '../../../../Tooltip'

const Tooltip = function($containerEl)
{
    BaseTooltip.call(this, $containerEl);
};

Tooltip.prototype = _.create(BaseTooltip.prototype, {
    html: "<div id='viewTTPageDetailsTableDayRowTooltip'></div>",

    updateDate: function(date)
    {
        if (!this.date || this.date.getTime() != date.getTime())
        {
            this.date = date;
            var weekStart = this.date.getWeekStartDate(ViewTTStore.getWeekStartDay());
            var weekEnd = weekStart.getNDaysAfter(6);
            var weekStartStr = Tooltip.dateFormat.formatDate(weekStart);
            var weekEndStr = Tooltip.dateFormat.formatDate(weekEnd);
            this.$el.html(messageResource.getMessage("view_tt.details_table.tooltip_html", [weekStartStr, weekEndStr]));
        }
    }
});

Tooltip.getInstance = function()
{
    if (!this._instance)
        this._instance = new this($("body")).init();
    return this._instance;
};

Tooltip.dateFormat = new DateFormat("MMM dd");

export default Tooltip


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/dayRow/Tooltip.js